export default __webpack_public_path__ + "abcde55476f31828e3aafef751460e5d.png";